import { ReactNode } from "react";

import { QueryProvider, NonPersistQueryProvider } from "./Query";
import ThemeProviders from "./Theme";

const QueryProviderComponent =
  import.meta.env.VITE_APP_TEST_MODE === "server" ? NonPersistQueryProvider : QueryProvider;

function Providers({ children }: { children: ReactNode; cache?: boolean }) {
  return (
    <QueryProviderComponent>
      <ThemeProviders>{children}</ThemeProviders>
    </QueryProviderComponent>
  );
}

export default Providers;
